import { getTextStyles, Typography } from '@braskai/ui-kit';

import { css, Stack, styled } from '@mui/material';

import { Progressbar } from '@/shared/ui/Progressbar';

export const SContainer = styled(Stack)(
  () => css`
    gap: 8px;
    border-radius: 12px;
  `,
);

export const SContent = styled(Stack)(
  ({ theme }) => css`
    display: flex;
    justify-content: space-between;
    gap: 6px;

    ${theme.breakpoints.up('tablet')} {
      flex-direction: row;
      gap: 0;
    }
  `,
);

export const SUsed = styled(Typography)(
  ({ theme }) => css`
    display: flex;
    gap: 4px;
    align-items: center;

    ${theme.breakpoints.up('tablet')} {
      ${getTextStyles('body-1-md')};
    }
  `,
);

export const SHint = styled(Typography)(
  ({ theme }) => css`
    ${theme.breakpoints.up('tablet')} {
      ${getTextStyles('body-2')};
    }
  `,
);

export const SBarContainer = styled(Stack)(
  () => css`
    width: 100%;
    align-self: center;
  `,
);

export const SProgress = styled(Progressbar)(
  () => css`
    height: 4px;
  `,
);
